import styled from "styled-components/macro";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

export const GCLearnMoreWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const getLearnMoreWidth = (deviceType: DeviceType) => {
  if (deviceType === "desktop") {
    return "920px";
  }
  if (deviceType === "tablet") {
    return "570px";
  }
  return "360px";
};

const getLearnMorePadding = (deviceType: DeviceType) => {
  if (deviceType === "desktop") {
    return "90px 40px 142px 40px";
  }
  if (deviceType === "tablet") {
    return "60px 18px 112px 18px";
  }
  return "40px 16px 92px 16px";
};

export const GCLearnMoreComponentWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  grid-template-columns: ${({ deviceType }) =>
    deviceType === "mobile" ? "100%" : getLearnMoreWidth(deviceType)};
  padding: ${({ deviceType }) => getLearnMorePadding(deviceType)};
  width: 100%;
  max-width: ${({ deviceType }) => {
    if (deviceType === "desktop") return "920px";
    if (deviceType === "tablet") return "570px";
    return "100%";
  }};
`;

const getImageWidth = (deviceType: DeviceType) => {
  if (deviceType === "desktop") {
    return "860px";
  }
  if (deviceType === "tablet") {
    return "540px";
  }
  if (deviceType === "mobile") {
    return "330px";
  }
};

const getImageHeight = (deviceType: DeviceType) => {
  if (deviceType === "desktop") {
    return "573px";
  }
  if (deviceType === "tablet") {
    return "360px";
  }
  if (deviceType === "mobile") {
    return "215px";
  }
};

export const GCLearnMoreImageWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: flex;
  justify-content: center;

  img {
    width: ${({ deviceType }) => getImageWidth(deviceType)};
    height: ${({ deviceType }) => getImageHeight(deviceType)};
    border-radius: 16px;
    object-fit: cover;
  }
`;

export const GCLearnMoreBackLink = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  max-width: 175px;
  cursor: pointer;
`;

export const GCLearnMoreComponentGrid = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  grid-template-rows: auto auto auto;
  grid-row-gap: 20px;
`;

export const GCLearnMoreContentWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.white};
  padding: 24px;
  border-radius: 24px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  gap: 20px;

  .gc-learn-more-top {
    max-width: 100%;
    padding-top: 20px;
  }

  .gc-learn-more-section {
    padding: 10px 0;
  }

  .gc-learn-more-link {
    color: ${({ theme }) => theme.redMedium};
    text-decoration: underline;
    cursor: pointer;
  }
`;
